<template>
  <div class="prelim-container">
    <div class="heading font-secondary">{{ studyName }}</div>
    <div class="each-row regular-text">{{ $t("thankYouParticipation") }}</div>
    <div class="each-row regular-text"></div>
    <div class="each-row regular-text">
      <div class="left-side">
        <div>{{ $t("age") }}</div>
      </div>
      <div class="right-side">
        <Dropdown :selection="selectedAgeRange">
          <div class="option" v-for="age_range in getAgeRanges" @click="setAgeRange(age_range)">
            <span class="options-text">{{ age_range }}</span>
          </div>
        </Dropdown>
        <span class="error" v-show="errors.age">*{{ requiredFieldText }}</span>
      </div>
    </div>
    <div v-if="!isDeitel" class="each-row regular-text">
      <div class="left-side">
        <div>{{ $t("yearBornQuestion") }}</div>
      </div>
      <div class="right-side">
        <input class="input-box" v-model="yearBorn" :placeholder="yearBornExample" />
        <span class="error" v-show="errors.year">*{{ requiredFieldText }}</span>
      </div>
    </div>
    <div class="each-row regular-text">
      <div class="left-side">
        <div>{{ $t("genderIdentification") }}</div>
      </div>
      <div class="right-side">
        <Dropdown :selection="selectedGender">
          <div class="option" v-for="gender in getGenders" @click="setGender(gender)">
            <span class="options-text">{{ gender }}</span>
          </div>
        </Dropdown>
        <span class="error" v-show="errors.gender">*{{ requiredFieldText }}</span>
      </div>
    </div>
    <div
      v-for="segmentQuestion in segmentQuestions"
      :key="segmentQuestion.id"
      class="each-row regular-text"
    >
      <div class="left-side">
        <div>{{ segmentQuestion.question }}</div>
      </div>
      <div class="right-side">
        <Dropdown :selection="getSelectedAnswer(segmentQuestion)">
          <div
            class="option"
            v-for="(answer, idx) in segmentQuestion.answers"
            :key="idx"
            @click="setAnswer(segmentQuestion.id, answer)"
          >
            <span class="options-text">{{ answer }}</span>
          </div>
        </Dropdown>
        <span class="error" v-show="shouldShowSegmentAnswerError(segmentQuestion)"
          >*{{ requiredFieldText }}</span
        >
      </div>
    </div>
    <div class="each-row regular-text">
      <div class="left-side-checkbox" :class="rtl">
        <div style="white-space: pre-wrap;">{{ privacyInfo }}</div>
      </div>
      <div class="right-side-checkbox">
        <input type="checkbox" id="checkbox" v-model="checked" />
        <div class="error" v-show="errors.checkBox">*{{ requiredFieldText }}</div>
      </div>
    </div>
    <div>
      <div class="next-button" :class="rtl">
        <button class="pure-button bigmi-red-2-button" v-on:click="postPrelimToServer">
          {{ $t("next") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Dropdown from "../general/Dropdown";
import http from "../../services/axios";

import { GET_BACKEND_URL, IS_SURVEY_RTL, USER_POSITION_IN_SURVEY } from "../../services/constants";
import CookieService from "../../services/cookies";
import { mapGetters } from "vuex";

export default {
  name: "SurveyPrelim",

  components: {
    Dropdown,
  },

  data() {
    return {
      studyID: this.$store.state.surveyModule.survey.data.study.id,
      selectedAgeRange: this.$t("choose"),
      selectedGender: this.$t("choose"),
      selectedAnswers: this.$store.state.surveyModule.survey.data.study.segmentQuestions.map(
        (segmentQuestion) => {
          return { segmentQuestionId: segmentQuestion.id, segment: this.$t("choose") };
        }
      ),
      yearBorn: null,
      checked: false,
      errors: {
        age: false,
        gender: false,
        year: false,
        segmentAnswers: this.segmentAnswersErrorsConstructor(),
        checkBox: false,
      },
    };
  },
  methods: {
    postPrelimToServer(event) {
      this.resetErrors();
      let readyToSend = this.isFormComplete();
      if (readyToSend) {
        if (this.$store.state.surveyModule.isSurveyPreview) {
          this.$store.dispatch(USER_POSITION_IN_SURVEY, { sendToPrelim: false });
        } else {
          const objToPost = this.createObjectToPost();
          return http
            .post(
              this.$store.getters[GET_BACKEND_URL](
                `studies/${this.studyID}/participants/${this.$route.params.survey_id}`
              ),
              objToPost
            )
            .then((response) => {
              this.$store.dispatch(USER_POSITION_IN_SURVEY, { sendToPrelim: false });
            })
            .catch((err) => {
              console.error(err);
            });
        }
      }
    },

    resetErrors() {
      this.errors = {
        age: false,
        gender: false,
        year: false,
        segmentAnswers: this.segmentAnswersErrorsConstructor(),
        checkBox: false,
      };
    },

    isFormComplete() {
      if (this.selectedAgeRange === this.$t("choose")) {
        this.errors.age = true;
      }

      if (!this.yearBorn && !this.isDeitel) {
        this.errors.year = true;
      }

      if (this.selectedGender === this.$t("choose")) {
        this.errors.gender = true;
      }

      this.errors.segmentAnswers.forEach((err) => {
        const selectedAnswer = this.selectedAnswers.find(
          (answer) => answer.segmentQuestionId === err.id
        );
        if (selectedAnswer.segment === this.$t("choose")) {
          err.value = true;
        }
      });

      if (this.checked === false) {
        this.errors.checkBox = true;
      }

      let readyToSend = Object.keys(this.errors).every((k) => {
        if (Array.isArray(this.errors[k])) {
          return this.errors[k].every((item) => !item.value);
        } else {
          return !this.errors[k];
        }
      });
      return readyToSend;
    },

    createObjectToPost() {
      let cookie = this.getCookie();
      let objToReturn = {};
      objToReturn["age"] = this.getAgeRanges.indexOf(this.selectedAgeRange) + 1;
      objToReturn["birthYear"] = this.yearBorn;
      objToReturn["gender"] = this.getGenders.indexOf(this.selectedGender) + 1;
      objToReturn["segments"] = this.segmentForServer;
      objToReturn["cookieIdentifier"] = cookie;
      return objToReturn;
    },

    getCookie() {
      let cookie = CookieService.getByKey("identifier");
      if (!cookie) {
        let cookie = this.createUniqueIdentifier(130, 32);
        CookieService.set("identifier", cookie);
      }
      return cookie;
    },

    createUniqueIdentifier(bits, base) {
      if (!base) base = 16;
      if (bits === undefined) bits = 128;
      if (bits <= 0) return "0";

      let digits = Math.log(Math.pow(2, bits)) / Math.log(base);
      for (let i = 2; digits === Infinity; i *= 2) {
        digits = (Math.log(Math.pow(2, bits / i)) / Math.log(base)) * i;
      }

      let rem = digits - Math.floor(digits);

      let res = "";

      for (let i = 0; i < Math.floor(digits); i++) {
        let x = Math.floor(Math.random() * base).toString(base);
        res = x + res;
      }

      if (rem) {
        let b = Math.pow(base, rem);
        let x = Math.floor(Math.random() * b).toString(base);
        res = x + res;
      }

      let parsed = parseInt(res, base);
      if (parsed !== Infinity && parsed >= Math.pow(2, bits)) {
        return hat(bits, base);
      } else return res;
    },

    setAgeRange(evt) {
      this.selectedAgeRange = evt;
    },

    setGender(evt) {
      this.selectedGender = evt;
    },

    setAnswer(segmentQuestionId, segment) {
      let currentAnswer = this.selectedAnswers.find(
        (a) => a.segmentQuestionId === segmentQuestionId
      );
      currentAnswer.segment = segment;
    },

    getSelectedAnswer(segmentQuestion) {
      const segmentQuestionId = segmentQuestion.id;
      return this.selectedAnswers.find((a) => a.segmentQuestionId === segmentQuestionId).segment;
    },

    initSelectedAnswers() {
      this.selectedAnswers = this.segmentQuestions.map((segmentQuestion) => {
        return { segmentQuestionId: segmentQuestion.id, segment: this.$t("choose") };
      });
    },

    initSegmentAnswersErrors() {
      this.$store.state.surveyModule.survey.data.study.segmentQuestions.map((segmentQuestion) => {
        return (this.errors.segmentAnswers[segmentQuestion.id] = false);
      });
    },

    shouldShowSegmentAnswerError(segmentQuestion) {
      return this.errors.segmentAnswers.find(
        (segmentAnswer) => segmentAnswer.id === segmentQuestion.id
      ).value;
    },

    segmentAnswersErrorsConstructor() {
      return this.$store.state.surveyModule.survey.data.study.segmentQuestions.map(
        (segmentQuestion) => {
          const obj = { id: segmentQuestion.id, value: false };
          return obj;
        }
      );
    },
  },

  computed: {
    ...mapGetters([IS_SURVEY_RTL]),
    segmentQuestions() {
      return this.$store.state.surveyModule.survey.data.study.segmentQuestions;
    },
    studyName() {
      return this.$store.state.surveyModule.survey.data.study.name;
    },
    getAgeRanges() {
      return this.$t("ageRange");
    },
    isProspx() {
      return this.$store.state.surveyModule.survey.data.study.brand === "prospx";
    },
    isDeitel() {
      return this.$store.state.surveyModule.survey.data.study.id === 4509
    },
    getGenders() {
      return this.$t("genders");
    },
    requiredFieldText() {
      return this.$t("requiredField");
    },
    yearBornExample() {
      return this.$t("exampleYear");
    },
    rtl() {
      return { rtl: this[IS_SURVEY_RTL] };
    },
    privacyInfo() {
      if (this.isDeitel) {
        return "Hi,\n" +
          "\n" +
          "My name is Pnina Deitel and I am pursuing a Master’s Degree in Clinical Psychology at Achva Academic College in Israel. \n" +
          "\n" +
          "In this study, I seek to examine a teacher's current ability to recognize the early signs of autism in children and if they know when to refer the child to a medical professional to undergo a proper evaluation. You will be shown 25 screens with vignettes that describe certain behavior of a child. On a scale of 1 - 5 you will then decide if medical intervention is necessary. The study takes 5 - 10 minutes to complete.\n" +
          "\n" +
          "The study does not ask you to share any personal information or to identify yourself in any way. You will remain completely anonymous. In the areas where there is a question that allows you to write whatever you want, we ask that you please don’t share any personal (identifying) information.\n" +
          "\n" +
          "Your participation in the study is your choice, and you can of course stop at any time.\n" +
          "\n" +
          "I thank you for your agreement and participation in the study. Checking the box below and proceeding to the next screen confirms your willingness to participate in this study.\n" +
          "\n" +
          "For any questions you may have regarding your participation in the study, please contact me at 1-713-893-0747 or by email: pninadeitel@gmail.com.\n" +
          "\n" +
          "Thank you,\n" +
          "\n" +
          "Pnina Deitel\n"
      }
      else {
        return this.$t("informationPrivacy")
      }
    },
    segmentForServer() {
      return this.selectedAnswers.map((answer) => {
        let segment = 0;
        this.segmentQuestions.forEach(function (segmentQuestion) {
          const segmentIndex = segmentQuestion.answers.indexOf(answer.segment);
          if (segmentIndex >= 0) {
            segment = segmentIndex + 1;
          }
        });
        return { segmentQuestionId: answer.segmentQuestionId, segment };
      });
    },
  },

  mounted() {
    this.initSelectedAnswers();
  },
};
</script>

<style scoped lang="scss">
@import "../../scss/main";

.heading {
  color: $red-2;
  font-size: 17px;
  font-weight: bold;
  padding: 2% 0;
}

.regular-text {
  font-size: 15px;
  font-weight: 100;
  @media #{$mobile} {
    font-size: 14px;
  }
}

.error {
  color: red;
}

.errors {
}

.error-month {
  display: inline-block;
  width: 55%;
}

.error-day {
  display: inline-block;
  width: 35%;
}

.prelim-container {
  padding-top: 3%;
  width: 80%;
  max-width: 1024px;
}

.options-text {
  font-size: 16px;
  @media #{$mobile} {
    font-size: 14px;
  }
}

.options-text-month-day {
  font-size: 16px;
  @media #{$mobile} {
    font-size: 10px;
  }
}

.next-button {
  float: right;
}

.next-button.rtl {
  float: left;
}

.button {
  border-color: $red-2;
  font-weight: bold;
  background-color: $white-1;
  border-width: medium;
  color: $red-2;
  border-radius: 5px;
  padding: 10px 20px;
}

.input-box {
  width: 100%;
  border: $gray-1;
  height: 40px;
  background-color: $gray-1;
  text-indent: 10px;
  @media #{$mobile} {
    height: 20px;
  }
}

.left-side {
  display: inline-block;
  width: 40%;
  min-height: 40px;
  vertical-align: top;
}

.right-side {
  display: inline-block;
  width: 60%;
}

.left-side-checkbox {
  display: inline-block;
  width: 55%;
  min-height: 40px;
  vertical-align: top;
  padding-right: 5%;
}

.left-side-checkbox.rtl {
  padding-right: 0;
}

.right-side-checkbox {
  display: inline-block;
  width: 40%;
  vertical-align: bottom;
}

.month-picker {
  display: inline-block;
  width: 55%;
  @media #{$mobile} {
    font-size: 10px;
  }
  /*padding-right: 5%;*/
}

.day-picker {
  display: inline-block;
  width: 35%;
  @media #{$mobile} {
    font-size: 10px;
  }
  /*padding-left: 5%;*/
}

.each-row {
  padding-top: 10px;
  padding-bottom: 10px;
}

.filler {
  display: inline-block;
  width: 10%;
}

.option {
  padding: 5px 20px;
  border: 1px solid rgba(0, 0, 0, 0.25);
  cursor: pointer;

  @media #{$mobile} {
    padding: 5px;
    font-size: 10px;
  }
}

.option:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

input[placeholder] {
  text-overflow: ellipsis;
}

::-moz-placeholder {
  text-overflow: ellipsis;
}

/* firefox 19+ */
input:-moz-placeholder {
  text-overflow: ellipsis;
}
</style>
